export const isHLS = url => {
  if (!url) {
    return false
  }
  return url.includes('m3u')
}
